import React, { useEffect } from 'react';

import Login from './login/Login';
import Registration from './registration/Registration';
import Reset from './reset/Reset';
import Sidebar from './sidebar/Sidebar';
import Account from './account/Account';
import Reservation from './reservation/Reservation';
import EditReservation from './editReservation/EditReservation';
import AddReservation from './addReservation/AddReservation';

import { alertActions } from '../actions';
import { history } from '../helpers';

import { Switch, Route, Redirect, Router } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from "react-toastify";

import "react-datepicker/dist/react-datepicker.css";
import 'react-toastify/dist/ReactToastify.css';
import 'moment/locale/fr'
import 'react-confirm-alert/src/react-confirm-alert.css';

function App() {
  const alert = useSelector(state => state.alert);
  const globalState = useSelector(state => state.global);

  const dispatch = useDispatch();

  useEffect(() => {
    history.listen(() => {
      window.scrollTo(0, 0);
    });
  }, []);

  const notify = (alert) => {
    'alert-success' === alert.type ? toast.success(alert.message) : toast.error(alert.message);
    dispatch(alertActions.clear());
  };

  return (
    <div className="App">
      {alert.message && notify(alert)}
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
      />
      {globalState.loading &&
        <div className="loading">
          <div>Chargement...</div>
        </div>
      }
      <Router history={history}>
        <Sidebar></Sidebar>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/inscription" component={Registration} />
          <Route path="/reset" component={Reset} />
          <PrivateRoute path="/compte" component={Account} />
          <PrivateRoute exact path="/" component={Reservation} />
          <PrivateRoute exact path="/reservation/planning" component={AddReservation} />
          <PrivateRoute exact path="/reservation/:id" component={EditReservation} />
          <Redirect from="*" to="/" />
        </Switch>
      </Router>
    </div>
  );
}

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route {...rest} render={props => (
      localStorage.getItem('user')
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
  );
}

export default App;
